module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<dl class="stepped zero">\n    <dt>\n        <label for="type-select">' +
((__t = ( i18next.t('export_organization_data.category') )) == null ? '' : __t) +
'</label>\n    </dt>\n    <dd>\n        <select class=\'text\' id=\'type-select\'>\n            <option value="all">' +
((__t = ( i18next.t('common.all').capitalize() )) == null ? '' : __t) +
'</option>\n            <option value="sites">' +
((__t = ( i18next.t('glossary.sites').capitalize() )) == null ? '' : __t) +
'</option>\n            <option value="indicators">' +
((__t = ( i18next.t('glossary.indicators').capitalize() )) == null ? '' : __t) +
'</option>\n            <option value="tariffs">' +
((__t = ( i18next.t('glossary.tariffs').capitalize() )) == null ? '' : __t) +
'</option>\n            <option value="integrations">' +
((__t = ( i18next.t('glossary.integrations').capitalize() )) == null ? '' : __t) +
'</option>\n            <option value="contracts">' +
((__t = ( i18next.t('glossary.contracts').capitalize() )) == null ? '' : __t) +
'</option>\n        </select>\n    </dd>\n</dl>\n';

}
return __p
}